import { render, staticRenderFns } from "./RewardsListItem.vue?vue&type=template&id=ba7f14da&"
import script from "./RewardsListItem.vue?vue&type=script&lang=ts&"
export * from "./RewardsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports